import { Grid, Paper } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import { UserSettingsTabNavigation } from './userSettingsTabNavigation';

export const UserSettingsLayout = () => {
  const { t } = useTranslation(['user']);

  return (
    <GridWrapper>
      <Grid item xs={12} md={6}>
        <MainContentHeader title={t('user:listUserHeader')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <UserSettingsTabNavigation />
          <Outlet />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
